export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const DATE_TIME_FORMAT_BAR = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_FORMAT_BAR_COMPLETE = 'DD/MM/YYYY HH:mm:ss';
